import styled from 'styled-components'
import { createGlobalStyle } from 'styled-components'

export const colorBlack = '#252525'
export const primaryColor = '#13143A'

export const GlobalStyle = createGlobalStyle`
    /* Cores do sistema por papel (claro). O modo escuro redefine as mesmas variáveis. */
    :root {
        --yrm-bg: #ffffff;
        --yrm-surface: #ffffff;
        --yrm-surface-2: #ffffff;
        --yrm-surface-3: #f1f5f9;
        --yrm-border: #e5e7eb;
        --yrm-border-strong: #cbd5e1;
        --yrm-text: #1f2937;
        --yrm-text-2: #334155;
        --yrm-text-3: #64748b;
        --yrm-text-4: #94a3b8;
        --yrm-heading: #13143A;
        --yrm-primary: #13143A;
        --yrm-sucesso: #16a34a;
        --yrm-perigo: #dc2626;
        --yrm-on-primary: #ffffff;
        --yrm-link: #1f4fa3;
        --yrm-highlight: #eef4fd;
        /* fundos de destaque (avisos, seleção, status) */
        --yrm-tint-azul: #eef4fd;
        --yrm-tint-amarelo: #fffbe6;
        --yrm-tint-vermelho: #fff2f0;
        --yrm-tint-verde: #f6ffed;
        /* topo e menu lateral */
        --yrm-chrome-bg: #13143A;
        --yrm-chrome-borda: transparent;
        --yrm-chrome-ativo: #d6a93a;
        --yrm-busca-bg: #ffffff;
        --yrm-busca-texto: #1f2937;
        --yrm-busca-borda: transparent;
    }
    :root[data-tema='escuro'] {
        --yrm-tint-azul: rgba(110, 140, 255, 0.14);
        --yrm-tint-amarelo: rgba(214, 169, 58, 0.16);
        --yrm-tint-vermelho: rgba(255, 110, 110, 0.14);
        --yrm-tint-verde: rgba(110, 200, 140, 0.14);
        /* azul-marinho da marca no fundo e dourado nos destaques */
        --yrm-bg: #0e1029;
        --yrm-surface: #15173a;
        --yrm-surface-2: #1a1d45;
        --yrm-surface-3: #222552;
        --yrm-border: #2a2d5c;
        --yrm-border-strong: #3b3f74;
        --yrm-text: #e8e9f3;
        --yrm-text-2: #c9cbe0;
        --yrm-text-3: #9a9dbd;
        --yrm-text-4: #7a7ea3;
        --yrm-heading: #f1ede2;
        --yrm-primary: #d6a93a;
        --yrm-sucesso: #86efac;
        --yrm-perigo: #fca5a5;
        --yrm-on-primary: #13143A;
        --yrm-link: #e6c46a;
        --yrm-highlight: #262a5c;
        --yrm-chrome-bg: #13143A;
        --yrm-chrome-borda: #23264f;
        --yrm-chrome-ativo: #d6a93a;
        --yrm-busca-bg: #1a1d45;
        --yrm-busca-texto: #e8e9f3;
        --yrm-busca-borda: #2a2d5c;
    }
    /* Escuro: etiquetas discretas (fundo neutro, texto em tom claro da cor) */
    :root[data-tema='escuro'] .ant-tag {
        background: var(--yrm-surface-3) !important;
        border-color: transparent !important;
        color: var(--yrm-text-2);
    }
    :root[data-tema='escuro'] .ant-tag-green, :root[data-tema='escuro'] .ant-tag-success, :root[data-tema='escuro'] .ant-tag-lime { color: #86efac !important; }
    :root[data-tema='escuro'] .ant-tag-red, :root[data-tema='escuro'] .ant-tag-error, :root[data-tema='escuro'] .ant-tag-volcano, :root[data-tema='escuro'] .ant-tag-magenta { color: #fca5a5 !important; }
    :root[data-tema='escuro'] .ant-tag-gold, :root[data-tema='escuro'] .ant-tag-orange, :root[data-tema='escuro'] .ant-tag-warning, :root[data-tema='escuro'] .ant-tag-yellow { color: #fcd34d !important; }
    :root[data-tema='escuro'] .ant-tag-blue, :root[data-tema='escuro'] .ant-tag-processing, :root[data-tema='escuro'] .ant-tag-geekblue { color: #93c5fd !important; }
    :root[data-tema='escuro'] .ant-tag-purple { color: #d8b4fe !important; }
    :root[data-tema='escuro'] .ant-tag-cyan { color: #67e8f9 !important; }
    :root[data-tema='escuro'] .ant-tag-has-color { color: var(--yrm-text) !important; }

    /* Botão flutuante da Sofia: menor no celular */
    .sofia-flutuante { bottom: 24px; right: 24px; width: 58px; height: 58px; }
    @media (max-width: 768px) {
        .sofia-flutuante { bottom: 16px; right: 16px; width: 48px; height: 48px; font-size: 22px !important; border-radius: 14px !important; }
    }

    /* Lixeira do cartão: discreta, vermelha só ao passar o mouse */
    .lixeira-cartao.ant-btn { color: var(--yrm-text-4); }
    .lixeira-cartao.ant-btn:hover { color: #ef4444 !important; background: var(--yrm-tint-vermelho) !important; }

    /* Colunas do quadro: rolagem fina, só aparece ao passar o mouse */
    .coluna-kanban { scrollbar-width: thin; scrollbar-color: transparent transparent; }
    .coluna-kanban:hover { scrollbar-color: var(--yrm-border-strong) transparent; }
    .coluna-kanban::-webkit-scrollbar { width: 6px; }
    .coluna-kanban::-webkit-scrollbar-track { background: transparent; }
    .coluna-kanban::-webkit-scrollbar-thumb { background: transparent; border-radius: 6px; }
    .coluna-kanban:hover::-webkit-scrollbar-thumb { background: var(--yrm-border-strong); }

    /* Tabelas: cabeçalho discreto em maiúsculas */
    .ant-table-wrapper .ant-table-thead > tr > th {
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.4px;
        color: var(--yrm-text-3);
        background: var(--yrm-surface);
    }
    .ant-table-wrapper .ant-table-thead > tr > th::before { display: none; }
    body {
        background: var(--yrm-bg);
        color: var(--yrm-text);
    }

    * {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
        font-family: 'Open Sans', sans-serif;
    }
    
    /* Scroll moderno e personalizado */
    ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }
    
    ::-webkit-scrollbar-track {
        background: var(--yrm-surface-3);
        border-radius: 10px;
    }
    
    ::-webkit-scrollbar-thumb {
        background: var(--yrm-border-strong);
        border-radius: 10px;
        transition: background 0.2s ease;
    }
    
    ::-webkit-scrollbar-thumb:hover {
        background: #94a3b8;
    }
    
    /* Scroll específico para mobile - colado na borda direita */
    @media (max-width: 768px) {
        ::-webkit-scrollbar {
            width: 6px;
        }
        
        ::-webkit-scrollbar-track {
            background: transparent;
            border-radius: 0;
        }
        
        ::-webkit-scrollbar-thumb {
            background: #94a3b8;
            border-radius: 0;
            border-right: none;
        }
        
        /* Remove qualquer margem do scroll */
        html, body {
            scrollbar-gutter: stable;
        }
    }
    
    /* Para Firefox */
    html {
        scrollbar-width: thin;
        scrollbar-color: var(--yrm-border-strong) var(--yrm-surface-3);
    }
    
    /* Para Firefox em mobile */
    @media (max-width: 768px) {
        html {
            scrollbar-width: thin;
            scrollbar-color: #94a3b8 transparent;
        }
    }
    
    /* Remover scroll duplo */
    body {
        overflow-x: hidden;
    }
    
    /* Layout mobile - scroll colado na borda */
    @media (max-width: 768px) {
        body {
            padding-right: 0 !important;
            margin-right: 0 !important;
        }
        
        * {
            scrollbar-gutter: auto;
        }
        
        /* Remove qualquer espaçamento que possa afetar o scroll */
        #root {
            width: 100vw;
            max-width: 100vw;
            overflow-x: hidden;
        }
    }
    
    /* Tooltips: quebram linha e nunca passam da largura da tela */
    .ant-tooltip {
        max-width: min(320px, calc(100vw - 32px));
    }
    .ant-tooltip-inner {
        white-space: normal;
        word-break: break-word;
    }

    /* Ícone "?" de ajuda dos rótulos de formulário: discreto */
    .ant-form-item-label .ant-form-item-tooltip {
        color: #94a3b8;
    }

    .ant-statistic-content-value, .ant-statistic-content-value-int, .ant-statistic-content-value-decimal, .ant-statistic .ant-statistic-content-value {
        color: var(--yrm-heading) !important;
    }
`

export const BgContent = styled.div`
    /* Base: gradiente derivado da cor primária do sistema (botões etc.) */
    /* primaryColor = ${primaryColor} */
    background-image:
        linear-gradient(135deg, rgba(19, 20, 58, 0.92) 0%, rgba(27, 33, 79, 0.88) 60%, rgba(9, 11, 32, 0.95) 100%),
        radial-gradient(1100px circle at 15% -8%, rgba(27, 33, 79, 0.55) 0%, rgba(19, 20, 58, 0) 60%),
        /* Padrão SVG repetido super sutil (balança da justiça + circuito) */
        url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160"><g fill="none" stroke="%23ffffff" stroke-opacity="0.04" stroke-width="1"><path d="M80 36 l-12 24 h24 z M80 36 v60 M56 60 h48"/><circle cx="40" cy="120" r="12"/><circle cx="120" cy="120" r="12"/><path d="M20 100 h24 m-12 0 v20 M100 28 h20 m-10 0 v20 M80 120 h40 m-20 0 v16"/></g></svg>'),
        /* Noise super leve para dar textura semelhante a papel */
        url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64"><filter id="n"><feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="1" stitchTiles="stitch"/></filter><rect width="100%" height="100%" filter="url(%23n)" opacity="0.018"/></svg>');
    background-repeat: no-repeat, no-repeat, repeat, repeat;
    background-size: cover, cover, 160px 160px, 64px 64px;
    background-position: center, center, 0 0, 0 0;
    background-color: ${primaryColor};
    background-blend-mode: normal, multiply, overlay, normal;
    width: 100vw;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center; /* Centraliza verticalmente */
    overflow-y: auto;
    padding: 24px 12px;

    /* Camadas decorativas elegantes (light blobs + grain) */
    position: relative;

    /* Blob suave à esquerda-superior */
    &::before {
        content: '';
        position: absolute;
        top: -20vh;
        left: -10vw;
        width: 45vw;
        height: 45vh;
            background: radial-gradient(closest-side, rgba(19, 20, 58, 0.08), rgba(19, 20, 58, 0) 70%);
        filter: blur(12px);
        pointer-events: none;
    }

    /* Blob suave à direita-inferior */
    &::after {
        content: '';
        position: absolute;
        bottom: -15vh;
        right: -8vw;
        width: 40vw;
        height: 40vh;
                background: radial-gradient(closest-side, rgba(27, 33, 79, 0.07), rgba(27, 33, 79, 0) 70%);
        filter: blur(14px);
        pointer-events: none;
    }

    /* Suporte para telas menores */
    @media (max-width: 600px) {
            /* Centraliza também no mobile, com espaçamento superior para evitar corte pelo notch/barras */
            align-items: center;
            padding: 24px 12px;
            min-height: 100svh; /* usa viewport segura do mobile */
    }
`
